// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as landingRouteRouteImport } from './routes/(landing)/route'
import { Route as appRouteRouteImport } from './routes/(app)/route'
import { Route as LearnIndexRouteImport } from './routes/learn/index'
import { Route as FeaturedIndexRouteImport } from './routes/featured/index'
import { Route as PreviewRenderRouteImport } from './routes/preview/render'
import { Route as PreviewPronunciationRouteImport } from './routes/preview/pronunciation'
import { Route as PreviewAgentHarnessRouteImport } from './routes/preview/agent-harness'
import { Route as OauthConsentRouteImport } from './routes/oauth/consent'
import { Route as LearnMistakesRouteImport } from './routes/learn/mistakes'
import { Route as EmbedLessonIdRouteImport } from './routes/embed/$lessonId'
import { Route as LearnVersionIdRouteRouteImport } from './routes/learn/$versionId/route'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminThreadsRouteImport } from './routes/admin/threads'
import { Route as AdminCreditRouteImport } from './routes/admin/credit'
import { Route as AdminSubscriptionsRouteRouteImport } from './routes/admin/subscriptions/route'
import { Route as landingIndexRouteImport } from './routes/(landing)/index'
import { Route as appSettingsRouteRouteImport } from './routes/(app)/settings/route'
import { Route as LearnCoursesCourseIdRouteImport } from './routes/learn/courses/$courseId'
import { Route as LearnVersionIdIndexRouteImport } from './routes/learn/$versionId/index'
import { Route as LearnVersionIdRecordsRouteImport } from './routes/learn/$versionId/records'
import { Route as LearnVersionIdPrintRouteImport } from './routes/learn/$versionId/print'
import { Route as AdminSandboxIndexRouteImport } from './routes/admin/sandbox/index'
import { Route as landingTermsIndexRouteImport } from './routes/(landing)/terms/index'
import { Route as landingPrivacyIndexRouteImport } from './routes/(landing)/privacy/index'
import { Route as landingPricingIndexRouteImport } from './routes/(landing)/pricing/index'
import { Route as landingContactIndexRouteImport } from './routes/(landing)/contact/index'
import { Route as landingAboutIndexRouteImport } from './routes/(landing)/about/index'
import { Route as landingauthSignUpRouteImport } from './routes/(landing)/(auth)/sign-up'
import { Route as landingauthSignInRouteImport } from './routes/(landing)/(auth)/sign-in'
import { Route as landingauthResetPasswordRouteImport } from './routes/(landing)/(auth)/reset-password'
import { Route as landingauthMagicLinkRouteImport } from './routes/(landing)/(auth)/magic-link'
import { Route as landingauthForgotPasswordRouteImport } from './routes/(landing)/(auth)/forgot-password'
import { Route as appResourcesIndexRouteImport } from './routes/(app)/resources/index'
import { Route as appDashboardIndexRouteImport } from './routes/(app)/dashboard/index'
import { Route as appChatIndexRouteImport } from './routes/(app)/chat/index'
import { Route as appNarratorSessionIdRouteImport } from './routes/(app)/narrator/$sessionId'
import { Route as appDashboardReportsRouteImport } from './routes/(app)/dashboard/reports'
import { Route as appChatThreadIdRouteImport } from './routes/(app)/chat/$threadId'
import { Route as appSettingsUserRouteImport } from './routes/(app)/settings/user'
import { Route as appSettingsUsageRouteImport } from './routes/(app)/settings/usage'
import { Route as appSettingsSystemRouteImport } from './routes/(app)/settings/system'
import { Route as appSettingsSubscriptionRouteImport } from './routes/(app)/settings/subscription'
import { Route as appSettingsOrganizationRouteImport } from './routes/(app)/settings/organization'
import { Route as appSettingsDangerRouteImport } from './routes/(app)/settings/danger'
import { Route as appSettingsBillingRouteImport } from './routes/(app)/settings/billing'
import { Route as appSettingsAccountRouteImport } from './routes/(app)/settings/account'
import { Route as appDashboardAnalyticsUsageIndexRouteImport } from './routes/(app)/dashboard/analytics/usage/index'

const AdminRouteRoute = AdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const landingRouteRoute = landingRouteRouteImport.update({
            id: '/(landing)',getParentRoute: () => rootRouteImport
          })
const appRouteRoute = appRouteRouteImport.update({
            id: '/(app)',getParentRoute: () => rootRouteImport
          })
const LearnIndexRoute = LearnIndexRouteImport.update({
            id: '/learn/',path: '/learn/',getParentRoute: () => rootRouteImport
          })
const FeaturedIndexRoute = FeaturedIndexRouteImport.update({
            id: '/featured/',path: '/featured/',getParentRoute: () => rootRouteImport
          })
const PreviewRenderRoute = PreviewRenderRouteImport.update({
            id: '/preview/render',path: '/preview/render',getParentRoute: () => rootRouteImport
          })
const PreviewPronunciationRoute = PreviewPronunciationRouteImport.update({
            id: '/preview/pronunciation',path: '/preview/pronunciation',getParentRoute: () => rootRouteImport
          })
const PreviewAgentHarnessRoute = PreviewAgentHarnessRouteImport.update({
            id: '/preview/agent-harness',path: '/preview/agent-harness',getParentRoute: () => rootRouteImport
          })
const OauthConsentRoute = OauthConsentRouteImport.update({
            id: '/oauth/consent',path: '/oauth/consent',getParentRoute: () => rootRouteImport
          })
const LearnMistakesRoute = LearnMistakesRouteImport.update({
            id: '/learn/mistakes',path: '/learn/mistakes',getParentRoute: () => rootRouteImport
          })
const EmbedLessonIdRoute = EmbedLessonIdRouteImport.update({
            id: '/embed/$lessonId',path: '/embed/$lessonId',getParentRoute: () => rootRouteImport
          })
const LearnVersionIdRouteRoute = LearnVersionIdRouteRouteImport.update({
            id: '/learn/$versionId',path: '/learn/$versionId',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRouteRoute
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRouteRoute
          })
const AdminThreadsRoute = AdminThreadsRouteImport.update({
            id: '/threads',path: '/threads',getParentRoute: () => AdminRouteRoute
          })
const AdminCreditRoute = AdminCreditRouteImport.update({
            id: '/credit',path: '/credit',getParentRoute: () => AdminRouteRoute
          })
const AdminSubscriptionsRouteRoute = AdminSubscriptionsRouteRouteImport.update({
            id: '/subscriptions',path: '/subscriptions',getParentRoute: () => AdminRouteRoute
          })
const landingIndexRoute = landingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => landingRouteRoute
          })
const appSettingsRouteRoute = appSettingsRouteRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => appRouteRoute
          })
const LearnCoursesCourseIdRoute = LearnCoursesCourseIdRouteImport.update({
            id: '/learn/courses/$courseId',path: '/learn/courses/$courseId',getParentRoute: () => rootRouteImport
          })
const LearnVersionIdIndexRoute = LearnVersionIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LearnVersionIdRouteRoute
          })
const LearnVersionIdRecordsRoute = LearnVersionIdRecordsRouteImport.update({
            id: '/records',path: '/records',getParentRoute: () => LearnVersionIdRouteRoute
          })
const LearnVersionIdPrintRoute = LearnVersionIdPrintRouteImport.update({
            id: '/print',path: '/print',getParentRoute: () => LearnVersionIdRouteRoute
          })
const AdminSandboxIndexRoute = AdminSandboxIndexRouteImport.update({
            id: '/sandbox/',path: '/sandbox/',getParentRoute: () => AdminRouteRoute
          })
const landingTermsIndexRoute = landingTermsIndexRouteImport.update({
            id: '/terms/',path: '/terms/',getParentRoute: () => landingRouteRoute
          })
const landingPrivacyIndexRoute = landingPrivacyIndexRouteImport.update({
            id: '/privacy/',path: '/privacy/',getParentRoute: () => landingRouteRoute
          })
const landingPricingIndexRoute = landingPricingIndexRouteImport.update({
            id: '/pricing/',path: '/pricing/',getParentRoute: () => landingRouteRoute
          })
const landingContactIndexRoute = landingContactIndexRouteImport.update({
            id: '/contact/',path: '/contact/',getParentRoute: () => landingRouteRoute
          })
const landingAboutIndexRoute = landingAboutIndexRouteImport.update({
            id: '/about/',path: '/about/',getParentRoute: () => landingRouteRoute
          })
const landingauthSignUpRoute = landingauthSignUpRouteImport.update({
            id: '/(auth)/sign-up',path: '/sign-up',getParentRoute: () => landingRouteRoute
          })
const landingauthSignInRoute = landingauthSignInRouteImport.update({
            id: '/(auth)/sign-in',path: '/sign-in',getParentRoute: () => landingRouteRoute
          })
const landingauthResetPasswordRoute = landingauthResetPasswordRouteImport.update({
            id: '/(auth)/reset-password',path: '/reset-password',getParentRoute: () => landingRouteRoute
          })
const landingauthMagicLinkRoute = landingauthMagicLinkRouteImport.update({
            id: '/(auth)/magic-link',path: '/magic-link',getParentRoute: () => landingRouteRoute
          })
const landingauthForgotPasswordRoute = landingauthForgotPasswordRouteImport.update({
            id: '/(auth)/forgot-password',path: '/forgot-password',getParentRoute: () => landingRouteRoute
          })
const appResourcesIndexRoute = appResourcesIndexRouteImport.update({
            id: '/resources/',path: '/resources/',getParentRoute: () => appRouteRoute
          })
const appDashboardIndexRoute = appDashboardIndexRouteImport.update({
            id: '/dashboard/',path: '/dashboard/',getParentRoute: () => appRouteRoute
          })
const appChatIndexRoute = appChatIndexRouteImport.update({
            id: '/chat/',path: '/chat/',getParentRoute: () => appRouteRoute
          })
const appNarratorSessionIdRoute = appNarratorSessionIdRouteImport.update({
            id: '/narrator/$sessionId',path: '/narrator/$sessionId',getParentRoute: () => appRouteRoute
          })
const appDashboardReportsRoute = appDashboardReportsRouteImport.update({
            id: '/dashboard/reports',path: '/dashboard/reports',getParentRoute: () => appRouteRoute
          })
const appChatThreadIdRoute = appChatThreadIdRouteImport.update({
            id: '/chat/$threadId',path: '/chat/$threadId',getParentRoute: () => appRouteRoute
          })
const appSettingsUserRoute = appSettingsUserRouteImport.update({
            id: '/user',path: '/user',getParentRoute: () => appSettingsRouteRoute
          })
const appSettingsUsageRoute = appSettingsUsageRouteImport.update({
            id: '/usage',path: '/usage',getParentRoute: () => appSettingsRouteRoute
          })
const appSettingsSystemRoute = appSettingsSystemRouteImport.update({
            id: '/system',path: '/system',getParentRoute: () => appSettingsRouteRoute
          })
const appSettingsSubscriptionRoute = appSettingsSubscriptionRouteImport.update({
            id: '/subscription',path: '/subscription',getParentRoute: () => appSettingsRouteRoute
          })
const appSettingsOrganizationRoute = appSettingsOrganizationRouteImport.update({
            id: '/organization',path: '/organization',getParentRoute: () => appSettingsRouteRoute
          })
const appSettingsDangerRoute = appSettingsDangerRouteImport.update({
            id: '/danger',path: '/danger',getParentRoute: () => appSettingsRouteRoute
          })
const appSettingsBillingRoute = appSettingsBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => appSettingsRouteRoute
          })
const appSettingsAccountRoute = appSettingsAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => appSettingsRouteRoute
          })
const appDashboardAnalyticsUsageIndexRoute = appDashboardAnalyticsUsageIndexRouteImport.update({
            id: '/dashboard/analytics/usage/',path: '/dashboard/analytics/usage/',getParentRoute: () => appRouteRoute
          })





const appSettingsRouteRouteChildren = {
  appSettingsAccountRoute: appSettingsAccountRoute,appSettingsBillingRoute: appSettingsBillingRoute,appSettingsDangerRoute: appSettingsDangerRoute,appSettingsOrganizationRoute: appSettingsOrganizationRoute,appSettingsSubscriptionRoute: appSettingsSubscriptionRoute,appSettingsSystemRoute: appSettingsSystemRoute,appSettingsUsageRoute: appSettingsUsageRoute,appSettingsUserRoute: appSettingsUserRoute
}

const appSettingsRouteRouteWithChildren = appSettingsRouteRoute._addFileChildren(appSettingsRouteRouteChildren)



const appRouteRouteChildren = {
  appSettingsRouteRoute: appSettingsRouteRouteWithChildren,appChatThreadIdRoute: appChatThreadIdRoute,appDashboardReportsRoute: appDashboardReportsRoute,appNarratorSessionIdRoute: appNarratorSessionIdRoute,appChatIndexRoute: appChatIndexRoute,appDashboardIndexRoute: appDashboardIndexRoute,appResourcesIndexRoute: appResourcesIndexRoute,appDashboardAnalyticsUsageIndexRoute: appDashboardAnalyticsUsageIndexRoute
}

const appRouteRouteWithChildren = appRouteRoute._addFileChildren(appRouteRouteChildren)




const landingRouteRouteChildren = {
  landingIndexRoute: landingIndexRoute,landingauthForgotPasswordRoute: landingauthForgotPasswordRoute,landingauthMagicLinkRoute: landingauthMagicLinkRoute,landingauthResetPasswordRoute: landingauthResetPasswordRoute,landingauthSignInRoute: landingauthSignInRoute,landingauthSignUpRoute: landingauthSignUpRoute,landingAboutIndexRoute: landingAboutIndexRoute,landingContactIndexRoute: landingContactIndexRoute,landingPricingIndexRoute: landingPricingIndexRoute,landingPrivacyIndexRoute: landingPrivacyIndexRoute,landingTermsIndexRoute: landingTermsIndexRoute
}

const landingRouteRouteWithChildren = landingRouteRoute._addFileChildren(landingRouteRouteChildren)




const AdminRouteRouteChildren = {
  AdminSubscriptionsRouteRoute: AdminSubscriptionsRouteRoute,AdminCreditRoute: AdminCreditRoute,AdminThreadsRoute: AdminThreadsRoute,AdminUsersRoute: AdminUsersRoute,AdminIndexRoute: AdminIndexRoute,AdminSandboxIndexRoute: AdminSandboxIndexRoute
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(AdminRouteRouteChildren)




const LearnVersionIdRouteRouteChildren = {
  LearnVersionIdPrintRoute: LearnVersionIdPrintRoute,LearnVersionIdRecordsRoute: LearnVersionIdRecordsRoute,LearnVersionIdIndexRoute: LearnVersionIdIndexRoute
}

const LearnVersionIdRouteRouteWithChildren = LearnVersionIdRouteRoute._addFileChildren(LearnVersionIdRouteRouteChildren)

const rootRouteChildren = {
  appRouteRoute: appRouteRouteWithChildren,landingRouteRoute: landingRouteRouteWithChildren,AdminRouteRoute: AdminRouteRouteWithChildren,LearnVersionIdRouteRoute: LearnVersionIdRouteRouteWithChildren,EmbedLessonIdRoute: EmbedLessonIdRoute,LearnMistakesRoute: LearnMistakesRoute,OauthConsentRoute: OauthConsentRoute,PreviewAgentHarnessRoute: PreviewAgentHarnessRoute,PreviewPronunciationRoute: PreviewPronunciationRoute,PreviewRenderRoute: PreviewRenderRoute,FeaturedIndexRoute: FeaturedIndexRoute,LearnIndexRoute: LearnIndexRoute,LearnCoursesCourseIdRoute: LearnCoursesCourseIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)